

<template>
  <div class="search-block">
    <div class="box container-width">
      <div class="select-mod">
        <div class="ip" style="width: 100%">
          <input
            type="text"
            id="xm_ks"
            v-model="doctor"
            onfocus="if(this.value=='科室名/医生姓名')this.value=''"
            onblur="if(this.value=='')this.value='科室名/医生姓名'"
            placeholder="科室名/医生姓名"
          />
        </div>
      </div>
      <a @click="handleSearchDoctor" class="pbbtn2">
        <div>
          <span>立即查询</span>
        </div>
      </a>
    </div>
  </div>
</template>
      
<script>
export default {
  name: "SEARCHBLOCK",
  props: {},
  data() {
    return {
      doctor: "", // 查询医生
    };
  },
  methods: {
    // 搜索科室/医生
    handleSearchDoctor() {
      let searchContent = this.doctor;
      const { href } = this.$router.resolve({
        path: `/ylts/search`,
        query: {
          type: "doctor", //要传的参数
          searchContent: `${searchContent}`,
        },
      });
      window.open(href, "_blank");
    },
  },
  mounted() {},
  watch: {},
  destroyed() {},
};
</script>
      
<style scoped lang="scss">
/* 搜索 */
.search-block {
  width: 100%;
  margin-top: 30px;
  .box {
    padding-left: 30px;
    padding-right: 30px;
    box-sizing: border-box;
    display: -webkit-flex;
    display: flex;
    border-radius: 5px;
    border-bottom: 5px solid #00479d;
    padding-bottom: 30px;
    -webkit-box-shadow: 0px 0px 24px 0px rgba(2, 2, 2, 0.05);
    box-shadow: 0px 0px 24px 0px rgba(2, 2, 2, 0.05);
    padding: 40px 55px;
    background: #fff;
    .tit1 {
      margin-right: 10px;
      font-size: 24px;
      float: left;
      line-height: 39px;
      height: 44px;
      margin-right: 24px;
    }
    .select-mod {
      flex: 1;
      margin-right: 50px;
      border: 1px solid #dcdcdc;
      border-radius: 5px;
      .ip {
        width: 95%;
        padding: 11px 15px;
      }
    }
    .pbbtn2 {
      float: right;
      font-size: 16px;
      color: #fff;
      width: 170px;
      height: 54px;
      text-align: center;
      line-height: 54px;
      position: relative;
      div {
        width: 100%;
        height: 100%;
        background: #00479d;
        border-radius: 5px;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 2;
        -webkit-transition: all 0.4s ease;
        transition: all 0.4s ease;
        -webkit-transform: translate(0, 0);
        transform: translate(0, 0);
        span {
          display: inline-block;
          -webkit-transition: all 0.4s ease;
          transition: all 0.4s ease;
        }
      }
    }
    .pbbtn2:after {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #dfdcdc;
      border-radius: 5px;
      z-index: 1;
      -webkit-transition: all 0.4s ease;
      transition: all 0.4s ease;
      -webkit-transform: translate(0, 0);
      transform: translate(0, 0);
    }
  }
}

@media only screen and (max-width: 728px) {
  .search-block {
    width: 100%;
    margin-top: 30px;
    .box {
      padding: 10px;
      box-sizing: border-box;
      .select-mod {
        flex: 1;
        margin-right: 15px;
        height: 48px;
        .ip {
          width: 95%;
          padding: 8px 15px;
          box-sizing: border-box;
          height: 100%;
          input {
            width: 100%;
            height: 100%;
          }
        }
      }
      .pbbtn2 {
        font-size: 12px;
        width: 60px;
        height: 48px;
      }
    }
  }
}
</style>
      
    
       